import React from 'react'
import {Box, Checkbox, Text} from '@chakra-ui/react'

const ConsentBox = ({
  isChecked,
  onChange,
  children,
  checkBoxLabel,
  consentTitle,
  isRequired,
}) => {
  return (
    <Box mt={5}>
      <Box ml={2} mb={6}>
        {' '}
        <Text fontWeight={'500'} textStyle="b2">
          {consentTitle}
          {isRequired && (
            <Text as="span" color="sr60" ml={1}>
              *
            </Text>
          )}
        </Text>
      </Box>

      <Box borderRadius={'.25rem'} m={2} p={4} bg="#F5F5F5">
        <Box m={5}>
          {children}{' '}
          <Box>
            <Checkbox
              mt={8}
              isChecked={isChecked}
              onChange={onChange}
              size="lg"
              mb={4}
            >
              {' '}
              {checkBoxLabel}
            </Checkbox>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default ConsentBox
